/**
 * Created by km on 2017-03-07.
 */
import React from 'react'

export default function question (props) {
  return (
    <section className='question ui vertical very fitted segment'>
      <h2 className={props.classes}>{props.q}</h2>
      <div className='ui very relaxed list'>
        {props.children}
      </div>
    </section>
  )
}

question.propTypes = {
  children: React.PropTypes.node,
  q: React.PropTypes.string.isRequired,
  classes: React.PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/question/index.js